import authAxios from "./config/need-auth-axios";

class pluginService {
  getPluginsList() {
    return authAxios.get("/plugins");
  }
}

export default new pluginService();
